/**
 * Utils : History
 * ---
 * Creates a HashHistory and returns it with the const "history".
 */

import { createHashHistory } from 'history'

export const history = createHashHistory()
